<template>
    <div>
        <span class="mr-1">Código:</span>
        <strong>{{ contratacao.codContratacao }}</strong>
        <br />
        <span class="mr-1">Objeto:</span>
        <strong>{{ contratacao.objeto }}</strong>
        <br />
        <span class="mr-1">Unidade:</span>
        <strong>{{ contratacao.unidade }}</strong>
        <br />
        <span class="mr-1">Gestor:</span>
        <strong>{{ contratacao.gestor }}</strong>
        <br />
        <span v-if="contratacao.gestorDesignado">
            <span class="mr-1">Gestor Designado:</span>
            <strong>{{ contratacao.gestorDesignado }}</strong>
            <br />
        </span>
        <span class="mr-1">Natureza:</span>
        <app-status :status="contratacao.natureza"></app-status>
    </div>
</template>

<script>
export default {
    props: {
        contratacao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    }
}
</script>
